class IntercomAnalytics {
  trackPage() {
    // Need to get event loop time to handle history push
    setTimeout(() => {
      // Remove TourConnect from document title
      // Remove all ObjectID in document title
      // Remove any double spaces
      this.track(`Viewed ${document.title.substr(0, document.title.indexOf('- TourConnect')).trim().replace(/[0-9a-fA-F]{24}/g, '').replace(/ +(?= )/g,'')}`);
    }, 0);
  }
  track(name, values) {
    try {
      window.Intercom('trackEvent', name, { // eslint-disable-line new-cap
        ...values,
      });
    } catch (e) {
      return;
    }
  }
}

const analyticsService = new IntercomAnalytics();

export default analyticsService;



// WEBPACK FOOTER //
// ./src/app/services/intercomAnalytics.js